export const GIT_COMMIT_HASH = "8088f883"
